
import React from 'react';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      id: '01',
      title: 'Get Your Quote',
      desc: 'Obtain an official price quotation from any authorized car dealer for the vehicle you want.'
    },
    {
      id: '02',
      title: 'Upload to dealmycar',
      desc: 'Upload your document securely on our portal. We accept PDFs, images, and excel sheets.'
    },
    {
      id: '03',
      title: 'Team Verification',
      desc: 'The dealmycar expert team verifies your quote against current factory margins and incentives.'
    },
    {
      id: '04',
      title: 'Get Beaten Price',
      desc: 'Receive a guaranteed minimum 1% extra discount, plus any additional eligibility-based savings.'
    }
  ];

  return (
    <section id="how-it-works" className="px-8 py-24 max-w-6xl mx-auto scroll-mt-24">
      <div className="text-center mb-16 space-y-4">
        <h2 className="text-4xl md:text-5xl font-display font-black uppercase italic tracking-tighter">
          How <span className="text-blue-500">dealmycar</span> Works
        </h2>
        <p className="text-gray-400 max-w-xl mx-auto">
          We use massive scale and direct dealer connections to force the price down. You win every time.
        </p>
      </div>

      <div className="grid md:grid-cols-4 gap-8">
        {steps.map((step) => (
          <div key={step.id} className="relative p-8 glass rounded-3xl border border-white/5 hover:border-blue-500/20 transition-all group">
            <div className="text-6xl font-black font-display text-blue-500/10 absolute top-4 right-6 group-hover:text-blue-500/20 transition-colors">
              {step.id}
            </div>
            <div className="relative z-10 space-y-4">
              <h3 className="text-xl font-bold text-white group-hover:text-blue-400 transition-colors">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {step.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
